import { Component, inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { ConfigService } from "../services/config.service";
import { MessageService } from "../services/message.service";
import { HeaderComponent } from "@ticket-team-com/tt-component-library";

@Component({
  selector: "app-main-layout-component",
  templateUrl: "./main-layout-component.component.html",
  styleUrls: ["./main-layout-component.component.css"],
  imports: [HeaderComponent, RouterOutlet],
})
export class MainLayoutComponentComponent implements OnInit {
  public currentLanguage = "NL";
  public title = "";
  public logoUrl = "";
  public languages: string[] = [];

  public configService = inject(ConfigService);
  private messageService = inject(MessageService);
  private titleService = inject(Title);

  ngOnInit() {
    const config = this.configService.getConfig();
    this.title = config.title;
    this.logoUrl = config.logoImage;
    this.languages = (config.languages ?? []).map((l) => l.language);
    this.titleService.setTitle(this.title);
  }

  onLangChange(lang: string) {
    this.currentLanguage = lang.toUpperCase();
    this.messageService.sendMessage(this.currentLanguage);
  }
}
